import GUI from 'lil-gui';

export function createStreetMaterialDebugUI(streetMaterial) {
   const gui = new GUI({ title: 'Street Material' });

   // Get current uniform values
   const repeatBaseX = streetMaterial.uniforms.repeatBase.value.x;
   const offsetBaseX = streetMaterial.uniforms.offsetBase.value.x;
   const offsetBaseY = streetMaterial.uniforms.offsetBase.value.y;
   const repeatStripesX = streetMaterial.uniforms.repeatStripes.value.x;
   const offsetStripesX = streetMaterial.uniforms.offsetStripes.value.x;
   const offsetStripesY = streetMaterial.uniforms.offsetStripes.value.y;
   const stripesIntensity = streetMaterial.uniforms.stripesIntensity.value;

   // Create params object for GUI
   const params = {
      repeatBase: repeatBaseX,
      offsetBaseX,
      offsetBaseY,
      repeatStripes: repeatStripesX,
      offsetStripesX,
      offsetStripesY,
      stripesIntensity,
   };

   // Base Gravel Controls
   const baseFolder = gui.addFolder('Base Gravel');
   baseFolder.add(params, 'repeatBase', 0.1, 50, 0.1).onChange((val) => {
      streetMaterial.uniforms.repeatBase.value.set(val, val);
   });
   baseFolder.add(params, 'offsetBaseX', 0, 1, 0.01).onChange((val) => {
      streetMaterial.uniforms.offsetBase.value.x = val;
   });
   baseFolder.add(params, 'offsetBaseY', 0, 1, 0.01).onChange((val) => {
      streetMaterial.uniforms.offsetBase.value.y = val;
   });
   baseFolder.open();

   // Stripes Overlay Controls
   const stripesFolder = gui.addFolder('Stripes Overlay');
   stripesFolder.add(params, 'repeatStripes', 0.1, 50, 0.1).onChange((val) => {
      streetMaterial.uniforms.repeatStripes.value.set(val, val);
   });
   stripesFolder.add(params, 'offsetStripesX', 0, 1, 0.01).onChange((val) => {
      streetMaterial.uniforms.offsetStripes.value.x = val;
   });
   stripesFolder.add(params, 'offsetStripesY', 0, 1, 0.01).onChange((val) => {
      streetMaterial.uniforms.offsetStripes.value.y = val;
   });
   stripesFolder.add(params, 'stripesIntensity', 0, 2, 0.1).onChange((val) => {
      streetMaterial.uniforms.stripesIntensity.value = val;
   });
   stripesFolder.open();

   // Copy values button
   gui.add(
      {
         copy: () => {
            const values = {
               repeatBase: params.repeatBase,
               offsetBase: [params.offsetBaseX, params.offsetBaseY],
               repeatStripes: params.repeatStripes,
               offsetStripes: [params.offsetStripesX, params.offsetStripesY],
               stripesIntensity: params.stripesIntensity,
            };
            console.log('Street Material Values:', values);
            console.log(JSON.stringify(values, null, 2));
         },
      },
      'copy',
   ).name('Copy to Console');

   return {
      gui,
      getValues: () => ({
         repeatBase: params.repeatBase,
         offsetBase: [params.offsetBaseX, params.offsetBaseY],
         repeatStripes: params.repeatStripes,
         offsetStripes: [params.offsetStripesX, params.offsetStripesY],
         stripesIntensity: params.stripesIntensity,
      }),
   };
}
